// extracted by mini-css-extract-plugin
export default {"content":"confirmModal_content__Lkb-Q","message":"confirmModal_message__qeHxT","buttonArea":"confirmModal_buttonArea__qQ40n","button":"confirmModal_button__AywH8"};